/**
 * z_variant-picker-wccg-inventory.js — Lagerbeholdning for WCCG Variant Picker
 * ==============================================================================
 * Del af: z_variant-picker-wccg snippet-pakken
 *
 * Filer i pakken:
 *   snippets/z_variant-picker-wccg.liquid          ← UI, styling, variant-data
 *   assets/z_variant-picker-wccg-cart.js            ← Cart: add, drawer, redirect
 *   assets/z_variant-picker-wccg-inventory.js       ← Lagerbeholdning + udsolgt badge (denne fil)
 *   assets/z_variant-picker-wccg-related.js         ← Relaterede produkter / upsell
 *
 * Funktionalitet:
 *   - Bruger Liquid-genereret inventory data (window.WCCG_inventory) via all_products[]
 *   - Sammenligner pack-antal (cfg_quantities) med tilgængelig beholdning
 *   - Springer over varianter UDEN lagerstyring (inventory_management = null)
 *   - Springer over varianter der sælges uden lager (inventory_policy = "continue")
 *   - Markerer udsolgte varianter med .wccg-vp__card--sold-out + vinklet badge
 *   - Markerer gave-boks som udsolgt hvis enten variant eller gave er udsolgt
 *   - Gave-boksen skjules IKKE — den vises altid, men markeres visuelt
 *
 * Afhængigheder:
 *   - Kræver window.WCCG (eksponeret af snippet'en)
 *   - Kræver window.WCCG_inventory (Liquid-genereret via all_products i snippet'en)
 *
 * Version: 1.10 | Build: 010 | Date: 2026-05-30
 *   Build 010: cfg_ignore_gift_oos — 3 modes (string).
 *     window.WCCG.ignoreGiftOos:
 *       'block' (default) → udsolgt gave markerer bundle UDSOLGT
 *       'mark'            → bundle aktiv, gave-boks markeres visuelt OOS
 *       'hide'            → bundle aktiv, gave-boks SKJULES helt
 *     For 'mark' og 'hide' fjernes data-gift-variant-id fra input så
 *     cart.js ikke prøver at tilføje udsolgt gave til kurv.
 *     Backward-compat: true → 'mark', false → 'block'.
 *   Build 009: cfg_ignore_gift_oos initial support (boolean).
 */
(function() {
  var W = window.WCCG;
  if (!W || !W.picker) return;

  function log(msg, data) {
    if (data !== undefined) console.log('[' + W.name + ':inventory] ' + msg, data);
    else console.log('[' + W.name + ':inventory] ' + msg);
  }

  log('module loaded');

  var inv = window.WCCG_inventory;
  if (!inv || Object.keys(inv).length === 0) {
    log('No Liquid inventory data (window.WCCG_inventory) — check skipped');
    log('Tip: set cfg_product_handles in snippet config');
    return;
  }

  log('Inventory data found for ' + Object.keys(inv).length + ' variants');

  /* ── Log alle kendte varianter som tabel ── */
  log('=== INVENTORY OVERSIGT ===');
  Object.keys(inv).forEach(function(vid) {
    var v = inv[vid];
    var stock = (v.inventory_quantity !== null && v.inventory_quantity !== undefined) ? v.inventory_quantity : 'N/A';
    var mgmt = v.inventory_management || 'none';
    var policy = v.inventory_policy || 'deny';
    var avail = v.available ? 'Ja' : 'Nej';
    log('  Variant ' + vid + ' | lager: ' + stock + ' | available: ' + avail + ' | mgmt: ' + mgmt + ' | policy: ' + policy);
  });
  log('=========================');

  function checkVariant(vid, requiredQty, label, isGift) {
    var v = inv[vid];
    if (!v) return { soldOut: false, reason: 'not in data' };

    if (!v.inventory_management || v.inventory_management === null) {
      return { soldOut: false, reason: 'no tracking' };
    }

    /* For gaver: ignorer policy — en udsolgt gave skal markere kortet udsolgt */
    if (!isGift && v.inventory_policy === 'continue') {
      return { soldOut: false, reason: 'sells when OOS' };
    }

    if (!v.available) {
      return { soldOut: true, reason: 'not available' + (isGift ? ' (gave)' : ''), stock: 0 };
    }

    var stock = (v.inventory_quantity !== null && v.inventory_quantity !== undefined) ? v.inventory_quantity : 0;
    if (stock < requiredQty) {
      return { soldOut: true, reason: 'insufficient (have ' + stock + ', need ' + requiredQty + ')' + (isGift ? ' (gave)' : ''), stock: stock };
    }

    return { soldOut: false, reason: 'in stock (' + stock + ')', stock: stock };
  }

  var soldOutCount = 0;

  /* ── Gave-OOS mode ──
     'block' (default) = udsolgt gave markerer bundle som UDSOLGT (gammel adfærd)
     'mark'            = bundle aktiv, gave-boks vises med visuel OOS-markering
     'hide'            = bundle aktiv, gave-boks SKJULES helt (kunden ser ingen gave)
     Backward-compat: true → 'mark', false → 'block' */
  var GIFT_MODE_RAW = W.ignoreGiftOos;
  var GIFT_MODE;
  if (GIFT_MODE_RAW === 'hide') {
    GIFT_MODE = 'hide';
  } else if (GIFT_MODE_RAW === 'mark' || GIFT_MODE_RAW === true || GIFT_MODE_RAW === 'true') {
    GIFT_MODE = 'mark';
  } else {
    GIFT_MODE = 'block';
  }
  if (GIFT_MODE !== 'block') {
    log('⚙️  cfg_ignore_gift_oos = "' + GIFT_MODE + '": udsolgte gaver ' +
        (GIFT_MODE === 'hide' ? 'SKJULES og bundle forbliver tilgængelig' :
                                 'markeres visuelt og bundle forbliver tilgængelig'));
  }

  /* ── Tjek hver variant-card ── */
  log('=== VARIANT CHECK ===');
  W.inputs.forEach(function(input, i) {
    var vid = input.dataset.variantId;
    var packQty = parseInt(input.dataset.quantity) || 1;
    var giftVid = input.dataset.giftVariantId;
    var label = W.labels[i];
    var wrap = label.closest('.wccg-vp__wrap');
    var title = label.querySelector('.wccg-vp__title');
    var cardName = title ? title.textContent.trim() : ('Card ' + i);

    var mainResult = checkVariant(vid, packQty, cardName, false);
    log('  ' + cardName + ' (' + packQty + ' stk) | variant ' + vid + ' → ' + mainResult.reason);

    var giftResult = { soldOut: false };
    if (giftVid && giftVid.length > 0 && giftVid !== '0') {
      giftResult = checkVariant(giftVid, 1, cardName + ' [gave]', true);
      log('  ' + cardName + ' [gave]  | variant ' + giftVid + ' → ' + giftResult.reason);
    }

    /* ── Bundle-status: main altid, gift kun hvis GIFT_MODE === 'block' ── */
    var isSoldOut = mainResult.soldOut || (GIFT_MODE === 'block' && giftResult.soldOut);

    /* ── Gave-boks håndtering ved udsolgt gave ── */
    if (giftResult.soldOut && wrap) {
      var giftBox = wrap.querySelector('.wccg-vp__gift');
      if (giftBox) {
        if (GIFT_MODE === 'hide') {
          /* Skjul gave-boks helt — kunden ser ikke at der manglede en gave */
          giftBox.style.display = 'none';
          /* Fjern gift-variant-id fra input så cart.js ikke prøver at tilføje udsolgt gave */
          input.removeAttribute('data-gift-variant-id');
          input.dataset.giftVariantId = '';
          input.removeAttribute('data-gift-quantity');
          input.dataset.giftQuantity = '0';
          /* Fjern visuel 'card--has-gift' så afrunding på card-bunden er korrekt */
          label.classList.remove('wccg-vp__card--has-gift');
        } else {
          /* 'block' eller 'mark' → visuel OOS-markering på gave-boks */
          giftBox.classList.add('wccg-vp__gift--sold-out');
          if (GIFT_MODE === 'mark') {
            /* Bundle kan stadig købes — fjern gift-variant-id så cart.js ikke prøver */
            input.removeAttribute('data-gift-variant-id');
            input.dataset.giftVariantId = '';
            input.removeAttribute('data-gift-quantity');
            input.dataset.giftQuantity = '0';
          }
        }
      }
    }

    if (isSoldOut) {
      soldOutCount++;

      input.disabled = true;
      label.classList.add('wccg-vp__card--sold-out');

      if (input.checked) {
        input.checked = false;
        label.classList.remove('wccg-vp__card--active');
      }

      var existing = label.querySelector('.wccg-vp__sold-out');
      if (!existing) {
        var badge = document.createElement('div');
        badge.className = 'wccg-vp__sold-out';
        badge.textContent = 'UDSOLGT';
        label.appendChild(badge);
      }

      log('  → ' + cardName + ' MARKERET UDSOLGT'
        + (mainResult.soldOut ? ' [variant: ' + mainResult.reason + ']' : '')
        + (giftResult.soldOut ? ' [gave: ' + giftResult.reason + ']' : ''));
    } else if (giftResult.soldOut) {
      log('  → ' + cardName + ' beholdt aktiv [gave udsolgt, mode=' + GIFT_MODE +
          (GIFT_MODE === 'hide' ? ' → gave skjult' : ' → gave markeret visuelt') + ']');
    }
  });
  log('=====================');

  if (soldOutCount > 0) {
    W.updateUI();
    log(soldOutCount + ' of ' + W.inputs.length + ' variants sold out');
  } else {
    log('All variants in stock');
  }
})();
